module.exports = __webpack_public_path__ + "static/media/36pic.21fefba7.jpg";